/**
 * 默认所有aixuexi.com子域名
 * @type {String}
 *
 * @example
 * locahost:8080 | 172.0.0.1:8080 => locahost | 172.0.0.1
 * www.aixuexi.com => .aixuexi.com
 */
// const DOMAIN = location.hostname.replace(/[a-z,0-9]+\./, '.')
const DOMAIN = '.aixuexi.com'
/**
 * 默认为当前文档位置的路径
 * @type {String}
 */
const PATH = '/'

/**
 * 是否https协议, 默认否
 * @type {Boolean}
 */
// const SECURE = false

/**
 * 过期的默认时间, 1天
 * @type {Number}
 */
const END_TIME = 60 * 60 * 24
export default {
  /**
   * 获取某个key的cookie
   *
   * @param {String} sKey
   * @returns {String} cookie的值
   */
  getItem(sKey) {
    let arr
    const reg = new RegExp('(^| )' + sKey + '=([^;]*)(;|$)')
    if (document.cookie.match(reg)) {
      arr = document.cookie.match(reg)
      // return unescape(arr[2])
      return decodeURIComponent(arr[2])
    }
    return null
  },
  /**
   * 设置克制
   *
   * @param {String} sKey key值
   * @param {String} sValue value值
   * @param {String|Number|Date} vEnd 过期时间
   * @param {String} sPath 根路径
   * @param {String} sDomain 域名
   * @param {Boolean} bSecure 安全
   * @returns
   */
  setItem(sKey, sValue, vEnd = null, sPath = '', sDomain = '', bSecure = false) {
    // eslint-disable-next-line no-useless-escape
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
      return false
    }

    let sExpires = ''
    if (vEnd) {
      switch (vEnd.constructor) {
        case Number:
          sExpires = vEnd === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : '; max-age=' + vEnd
          break
        case String:
          sExpires = '; expires=' + vEnd
          break
        case Date:
          sExpires = '; expires=' + vEnd.toUTCString()
          break
      }
    } else {
      // 不传默认为 1 天
      sExpires = '; max-age=' + END_TIME
    }
    document.cookie =
      encodeURIComponent(sKey) +
      '=' +
      encodeURIComponent(sValue) +
      sExpires +
      '; domain=' +
      (sDomain || DOMAIN) +
      '; path=' +
      (sPath || PATH) +
      ';'
    return true
  },
  /**
   * 清除cookie
   * @param {string} sKey cookie键
   * @param {string} sDomain cookie域
   * @param {string} sPath 路径
   * sKey 为空时，清除所有cookie
   */
  clear(sKey, sDomain = '', sPath = '') {
    const exp = new Date()
    exp.setTime(exp.getTime() - 60 * 60 * 1000)

    try {
      // eslint-disable-next-line no-useless-escape
      const cookieItems = document.cookie.match(/[^ =;]+(?=\=)/g) || []
      // const clearItems = domainCookies.filter(item => cookieItems.indexOf(item) >= 0)
      const keys = sKey ? [sKey] : cookieItems

      // eslint-disable-next-line no-void
      void (keys || []).forEach(item => {
        document.cookie = item + '=; expires=' + exp.toUTCString() + '; max-age=1' + '; domain=' + (sDomain || DOMAIN) + '; path=' + (sPath || PATH)
      })
    } catch (err) {
      console.log('cookie-clear-err' + JSON.stringify(err))
    }
  },
  clearKey(sKey) {
    const cookieString = sKey + '='
    const date = new Date()
    date.setTime(date.getTime() + -1 * 3600 * 24 * 1000)
    const expiresTime = ';expires=' + date.toGMTString()
    document.cookie = cookieString + expiresTime + ';path=/'
  }
}
